import {TableModels_mok} from "../../data/data-source/devices/deviceModels_mok_data";
import {Models} from "../../data/data-class/devices/deviceModelClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class ModelsRepository {
    static async getModelsList(text, pageNumber) {
        const data_req = {
            text: text.trim(),
            pagenumber: pageNumber,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/model", data_req)
            });

        const code = response.statusCode;
        const message = response.message;
        if (response.success) {
            const modelObject = response.data.models.map(
                (model) =>
                    new Models(
                        model.id,
                        model.modelname,
                        model.seriname,
                        model.environment,
                        model.useType,
                        model.testType,
                        model.countdevice,
                        model.sensore
                    )
            );
            const countAll = response.data.countAll;
            return {
                ModelsClassList: modelObject,
                countAllPages: countAll,
                code,
                message,
            };
        }

        return {

            code,
            message,
        };
    }

    static async delete(id) {
        const data = {
            id: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/model/delete", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }
}

class ModelDetailRepository {
    static async getDetail(id_page) {
        const data = {
            id_page: id_page,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/model/detail", data)
            });
        const details = response.data.detail;
        const code = response.statusCode;
        const message = response.message;
        return {
            details,
            code,
            message,
        };
    }

    static async delete(id) {
        ///WTF IS THIS
        const model = await TableModels_mok.delete(id);
        const code = response.statusCode;
        const message = response.message;
        return {
            code,
            massage,
        };
    }
}

class ModelAddRepository {
    static async modelAddedit(order) {
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/model/add", order)
            });
        // const data = await postRequestWithToken("/model/add", order);
        const status = response.message;
        const code = response.statusCode;
        return {
            status,
            code,
        };
    }
}

class ModelEditRepository {
    static async data(id_page) {
        const id = {
            id_page: id_page,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/model/add", id)

            });
        const status = response.message;
        const code = response.statusCode;
        let data = null
        if (response.success) {
            data = response.data.data;
            return {
                editdata: data,
                code,
                status,
            };
        }

        return {
            code,
            status,
        };
    }
}

export {ModelEditRepository};
export {ModelAddRepository};
export {ModelDetailRepository};
export {ModelsRepository};
